import { pageModel } from '../utils/model'
import modelExtend from 'dva-model-extend'
import {
  exportExcel,
  addCustomer, queryCustomers, queryCustomerInfo, updateCustomer, addFollow, updateFollow, addRisk, updateRisk, queryTableLink, queryRisk,
  queryCustomerFollows, addDemand, queryCustomerDemands, addReserve, queryCustomerReserves, updateReserve, batchAddReserve,
  queryOrderCount, queryReserveCount, queryConsumptionCount, queryExecutor, queryCompact, queryServiceType, queryCustomerHistory, queryBPSCustomerHistory
} from '@/services/customer'
import { updateReservationStatus } from '@/services/reserve'
import { queryBPSHostoryDetail, fetchStageExcel, fetchStageEndExcel, fetchExcel1, fetchSubsquentBrief, fetchServiceComolexExcel, queryNewEvaluation, fetchReportEvaluation } from '@/services/task'
import {
  operationCustomer, operationInti, quertDictsItem, queryClinicList, queryChannels, queryConsultantAll,
  queryClinicEmployeeByRole, queryCustomerStatusList
} from '@/services/basicinfo'
import { message } from 'antd'
import { pathMatchRegexp, downloadExcel } from '@/utils/utils'
import {
  addOrder,
  queryOrders,
  queryCustomsOrders,
  queryOrderInfo,
  deleteOrder,
  updateOrder,
  submitOrder, addFiles,
  queryOrderEmployees, cancelOrder,
  orderReserve,
  orderReservations
} from '@/services/order'
import {
  queryRequirementAnalysis,
  queryEvaluation,
  queryBPSDetail,
  queryDrawing,
  querySand,
  querySubsequent,
  queryHealing,
  queryMentalTraining,
  fetchServiceTeam
} from '@/services/task'
import { getDetectionResult } from '@/services/detection'
import { getScaleResult } from '@/services/scale'
import { CLINIC_KEY, CLINIC_NAME, HTTP_SUCCESS_CODE, USER_ID, ROLE_CODE } from '@/utils/consts'
import { queryEmployeesByClinicId } from '@/services/employee'
import { cloneDeep } from 'lodash'
import request from '@/utils/request'
import { BASE_API } from '@/utils/consts'
const PAGE_SIZE = 10

export default modelExtend(pageModel, {
  namespace: 'personalPotentialList',
  state: {
    list: [],
    tableLinkList: {},
    totalOrderAmount: 0,
    bspPrintLookvisibel: false,
    drawerVisible: false,
    modalVisible: false,
    modalType: 'add',
    demandVisible: false,
    demandType: 'add',
    demandItem: {},
    followVisible: false,
    followType: 'add',
    followItem: {},
    riskVisible: false, riskType: 'add', riskItem: {},
    reserveVisible: false,
    reserveType: 'add',
    reserveItem: {},
    editDetail: {},
    ConsultantList: [], // 心理顾问列表
    ClinicEmployee: [], // 私人管家列表
    customerStatusList: [], // 客户状态列表
    current: {
      info: {},
      demand: [],
      modify: [],
      order: [],
      follow: [],
      reserve: [],
      treatment: [],
      risk: [],
      compact: [],
    },
    loaded: {
      info: false,
      demand: false,
      modify: false,
      order: false,
      follow: false,
      reserve: false,
      statistics: false,
      treatment: false,
      risk: false,
      compact: false,
    },
    statistics: {
      orderCount: {},
      reserveCount: [],
      consumptionCount: []
    },
    consumptionTotal: {},
    statisticsPagination: {
      reserveCount: {
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal(total, range) {
          return `共 ${total} 条数据 当前显示 ${range[0]} - ${range[1]} 条数据`
        },
        current: 1,
        total: 0,
        pageSize: PAGE_SIZE,
      },
      consumptionCount: {
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal(total, range) {
          return `共 ${total} 条数据 当前显示 ${range[0]} - ${range[1]} 条数据`
        },
        current: 1,
        total: 0,
        pageSize: PAGE_SIZE,
      }
    },
    fchannels: [],
    schannels: [],
    classification: [],
    customerStatus: [],  // 客户状态
    ConsultantList: [], // 心理顾问列表
    ClinicEmployee: [], // 私人管家列表
    jobs: [],
    clinicList: [],
    reserveStatus: [],
    orderPagination: {
      current: 1,
      total: 0,
      pageSize: PAGE_SIZE
    },
    executorList: [],
    customerHistoryList: [],   //历史记录表
    customerHistoryPagination: {
      current: 1,
      total: 0,
      pageSize: PAGE_SIZE
    },
    detectionResultModalVisible: false,
    demandResultModalVisible: false,
    evaluationResultModalVisible: false,
    bpsResultModalVisible: false,
    scaleResultModalVisible: false,
    paintingResultModalVisible: false,
    sandResultModalVisible: false,
    subsequentResultModalVisible: false,
    healingResultModalVisible: false,
    homePsychologyResultModalVisible: false,
    clinicUserList: [],
    fiveTypeHistory: [],
    ExcelServiceComolexModal: false,
    ExcelServiceComolexData: {},
    StageExcelModal: false,
    StageExcelData: {},
    StageEndExcelModal: false,
    StageEndExcelData: {},
    ExcelRecordBriefModal: false,
    ExcelRecordBriefData: {},
    Excel1Modal: false,
    Excel1Data: {},
    Excel2Modal: false,
    Excel2Data: {},
    Excel3Modal: false,
    Excel3Data: {},
    serviceTeamList: {},
    showEvaluationNewModal: false,
    EvaluationNewModalData: {},
    // orderCount: {},
  },
  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(location => {
        if (pathMatchRegexp('/personal', location.pathname)) {
          // const clinicId = window.localStorage.getItem(CLINIC_KEY)
          // const payload = location.query && cloneDeep(location.query) || { pageNo: 1, pageSize: 20 }
          // const is_admin = localStorage.getItem(ROLE_CODE) == 'ROLE_CLINIC_ADMIN'
          // payload.reservationStatuses = payload.reservationStatuses && (payload.reservationStatuses === "''" ? [] : payload.reservationStatuses.split(','))
          // payload.firstChannelIds = payload.firstChannelIds && [payload.firstChannelIds]
          // payload.secondChannelIds = payload.secondChannelIds && (payload.secondChannelIds === "''" ? [] : payload.secondChannelIds.split(','))
          // payload.consultantDoctorId = payload.consultantDoctorId == undefined ?
          //   (!is_admin ? localStorage.getItem(USER_ID) : '')
          //   :
          //   payload.consultantDoctorId
          // dispatch({ type: 'querySecondChannels', payload: { parentId: payload.firstChannelIds && payload.firstChannelIds[0] } })
          // dispatch({ type: 'getConsultantAll', payload: { clinicId } })
          // dispatch({ type: 'fetchAllCustomerStatusList', payload: { locked: 0 } })
          // dispatch({ type: 'getClinicEmployeeByRole', payload: { clinicId, roleName: '私人管家' } })
          // dispatch({ type: 'queryReserveStatus' }).then(() => {
          //   dispatch({ type: 'queryDictionaryClassification' }).then(() => {
          //     dispatch({ type: 'query', payload })
          //   })
          // })
        }
      })
    },
  },
  effects: {
    // 创建订单
    * createOrder({ payload = {} }, { put, call }) {
      const res = yield call(addOrder, payload)

      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      message.success("创建订单成功")
      // yield put({type: 'reload'})
      yield put({ type: 'queryOrder', payload: { customerId: payload.customerId } })
      yield put({
        type: 'updateState',
        payload: {
          orderVisible: false,
        }
      })
    },
    * batchAddReserve({ payload = {} }, { put, call }) {
      const { code } = yield call(batchAddReserve, payload)
      if (code === 0) {
        message.success('添加预约成功')
      }
    },
    // 更新订单
    * updateOrder({ payload = {} }, { put, call }) {
      const res = yield call(updateOrder, payload)

      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      message.success('更新订单成功')
      yield put({
        type: 'updateState',
        payload: {
          orderVisible: false,
        }
      })

      yield put({ type: 'queryOrder', payload: { customerId: payload.customerId } })
    },
    // 绑定订单附件
    * addFiles({ payload = {} }, { put, call }) {
      const { code, data } = yield call(addFiles, payload)
      if (code === 0) {
        yield put({ type: 'queryCompact', payload: { customerId: payload.customerId } })
      }
    },
    // 提交订单
    * submitOrder({ payload = {} }, { put, call }) {
      const { code, data } = yield call(submitOrder, payload)
      if (code == 0) {
        message.success('提交订单成功')
        yield put({
          type: 'updateState',
          payload: {
            orderVisible: false,
          }
        })
        if (data && data.id && payload.fileUrlArray) {
          yield put({ type: 'addFiles', payload: { orderId: data.id, fileUrlArray: payload.fileUrlArray, customerId: payload.customerId } })
        }
        yield put({ type: 'queryOrder', payload: { customerId: payload.customerId } })
      }
    },

    // 删除订单
    * delOrder({ payload = {} }, { put, call, select }) {
      const res = yield call(deleteOrder, payload)

      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      message.success('删除订单成功')
      yield put({ type: 'queryOrder', payload: { customerId: payload.customerId } })
    },

    // 取消订单
    * cancelOrder({ payload = {} }, { put, call }) {
      const { orderId, customerId } = payload

      const res = yield call(cancelOrder, orderId)

      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      message.success('取消订单成功')
      yield put({ type: 'queryOrder', payload: { customerId: customerId } })
    },

    // 获取订单待预约明细
    * orderReservations({ payload = {} }, { put, call, select }) {
      const { code, data } = yield call(orderReservations, { ...payload })
      yield put({
        type: 'updateState',
        payload: {
          waitReserveList: data,
        }
      })
    },
    * updateReservationStatus({ payload = {} }, { put, call }) {
      const { code } = yield call(updateReservationStatus, payload)
      if (code === 0) {
        message.success('保存成功')
      }
    },
    * addPotentialCustomer({ payload = {} }, { put, call }) {
      const { code, data } = yield call(addCustomer, payload)
      if (code === 0) {
        message.success('保存成功')
        return data || {}
      }
    },
    * updatePotentialCustomer({ payload = {} }, { put, call }) {
      const { code } = yield call(updateCustomer, payload)
      if (code === 0) {
        message.success('保存成功')
      }
    },
    * addFollow({ payload = {} }, { put, call }) {
      const { code } = yield call(addFollow, payload)
      if (code === 0) {
        message.success('保存成功')
      }
    },
    * updateFollow({ payload = {} }, { put, call }) {
      const { code } = yield call(updateFollow, payload)
      if (code === 0) {
        message.success('保存成功')
      }
    },
    * addRisk({ payload = {} }, { put, call }) {
      const { code } = yield call(addRisk, payload)
      if (code === 0) {
        message.success('保存成功')
      }
    },
    * updateRisk({ payload = {} }, { put, call }) {
      const { code } = yield call(updateRisk, payload)
      if (code === 0) {
        message.success('保存成功')
      }
    },
    * addDemand({ payload = {} }, { put, call }) {
      const { code } = yield call(addDemand, payload)
      if (code === 0) {
        message.success('保存成功')
      }
    },
    * addReserve({ payload = {} }, { put, call }) {
      const { code } = yield call(addReserve, payload)
      if (code === 0) {
        message.success('保存成功')
      }
    },
    * updateReserve({ payload = {} }, { put, call }) {
      const { code } = yield call(updateReserve, payload)
      if (code === 0) {
        message.success('保存成功')
      }
    },
    * query({ payload = {} }, { put, call }) {
      const defaults = { pageNo: 1, pageSize: 20, sortField: 'createdAt', sortMethod: 'desc', currentUserClinicId: window.localStorage.getItem(CLINIC_KEY) }
      if (payload.type === "") {
        delete payload.type
      }
      payload.personalDoctorId = payload.personalDoctorName || payload.personalDoctorId
      payload.consultantDoctorId = payload.consultantDoctorName || payload.consultantDoctorId
      delete payload.personalDoctorName
      delete payload.consultantDoctorName
      const newPayload = { ...defaults, ...payload }

      const { data, code } = yield call(queryCustomers, newPayload)
      if (code === 0 && data) {
        const { rows = [] } = data
        const totalOrderAmount = rows && rows[0] && rows[0].totalOrderAmount
        yield put({
          type: 'updateState',
          payload: { totalOrderAmount }
        })
        yield put({
          type: 'querySuccess',
          payload: {
            list: rows,
            pagination: {
              current: Number(data.pageNo) || 1,
              pageSize: data.pageSize || 10,
              total: data.totalCount
            },
          },
        })
      }
      const { data: tableData, code: tableCode } = yield call(queryTableLink, { ...newPayload, waitPayAgain: '', customerStatusId: '', customerStatusTwoId: '', type: undefined })
      if (tableCode == 0) {
        yield put({
          type: 'updateState',
          payload: {
            tableLinkList: tableData
          }
        })
      }
    },
    * queryFirstChannels({ payload = {} }, { put, call }) {
      const { code, data } = yield call(queryChannels, { level: 1, clinicId: localStorage.getItem(CLINIC_KEY) })
      const newData = [{ id: 0, name: '空白待填', enable: true }, ...data]
      if (code === 0) {
        yield put({
          type: 'updateState',
          payload: {
            fchannels: newData,
          },
        })
      }
    },
    * querySecondChannels({ payload = {} }, { put, call }) {
      const { code, data } = yield call(queryChannels, { level: 2, clinicId: localStorage.getItem(CLINIC_KEY), ...payload })
      if (code === 0) {
        yield put({
          type: 'updateState',
          payload: {
            schannels: data,
          },
        })
      }
    },
    * queryDictionaryClassification({ payload = {} }, { put, call }) {
      const { code, data } = yield call(quertDictsItem, { type: 'CUSTOMER_CLASSIFICATION', pageSize: 1000, pageNo: 1 })
      if (code === 0) {
        yield put({
          type: 'updateState',
          payload: {
            classification: data.rows,
          },
        })
      }
    },
    * queryDictionaryCustomerStatus({ payload = {} }, { put, call }) {
      const { code, data } = yield call(quertDictsItem, { type: 'CUSTOMER_STATUS', pageSize: 1000, pageNo: 1 })
      if (code === 0) {
        yield put({
          type: 'updateState',
          payload: {
            customerStatus: data.rows,
          },
        })
      }
    },
    * queryDictionaryJobs({ payload = {} }, { put, call }) {
      const { code, data } = yield call(quertDictsItem, { type: 'OCCUPATION', pageSize: 1000, pageNo: 1 })
      if (code === 0) {
        yield put({
          type: 'updateState',
          payload: {
            jobs: data.rows,
          },
        })
      }
    },
    * queryReserveStatus({ payload = {} }, { put, call }) {
      const { code, data } = yield call(quertDictsItem, { type: 'RESERVATION_STATUS', pageSize: 1000, pageNo: 1 })
      if (code === 0) {
        yield put({
          type: 'updateState',
          payload: {
            reserveStatus: data.rows,
          },
        })
      }
    },
    * queryClinicList({ payload = {} }, { put, call, select }) {
      const currentUser = yield select(
        state => state.user.currentUser
      )
      const { code, data } = yield call(queryClinicList, {})
      if (code === 0) {
        if (window.localStorage.getItem(CLINIC_KEY)) {
          yield put({
            type: 'updateState',
            payload: {
              clinicList: data.filter(_ => _.id === window.localStorage.getItem(CLINIC_KEY))
            },
          })
        } else {
          yield put({
            type: 'updateState',
            payload: {
              clinicList: [{ shortName: '集团', id: 0 }, ...data]
            },
          })
        }
      }
    },
    * fetchAllCustomerStatusList({ payload = {} }, { put, call }) {
      const { data } = yield call(queryCustomerStatusList, payload)
      yield put({
        type: 'updateState',
        payload: {
          customerStatusList: data
        }
      })
    },
    * queryInfo({ payload = {} }, { put, call }) {
      yield put({
        type: 'updateState',
        payload: {
          drawerVisible: true,
        },
      })
      const { data } = yield call(queryCustomerInfo, payload)
      yield put({
        type: 'updateDetail',
        payload: {
          current: { info: data },
          loaded: { info: true },
        },
      })
      return data
    },
    * queryDemand({ payload = {} }, { put, call }) {
      const { data } = yield call(queryCustomerDemands, payload)
      yield put({
        type: 'updateDetail',
        payload: {
          current: { demand: data },
          loaded: { demand: true },
        },
      })
    },
    * queryFollow({ payload = {} }, { put, call }) {
      const { data } = yield call(queryCustomerFollows, payload)
      yield put({
        type: 'updateDetail',
        payload: {
          current: { follow: data },
          loaded: { follow: true },
        },
      })
    },
    * queryRisk({ payload = {} }, { put, call }) {
      const { data } = yield call(queryRisk, payload)
      yield put({
        type: 'updateDetail',
        payload: {
          current: { risk: data },
          loaded: { risk: true },
        },
      })
    },
    * getConsultantAll({ payload = {} }, { put, call }) {
      const { data } = yield call(queryConsultantAll, payload)
      yield put({
        type: 'updateState',
        payload: {
          ConsultantList: data
        },
      })
    },
    * getClinicEmployeeByRole({ payload = {} }, { put, call }) {
      const { data } = yield call(queryClinicEmployeeByRole, payload)
      yield put({
        type: 'updateState',
        payload: {
          ClinicEmployee: data
        },
      })
    },
    * queryFollowDialog({ payload = {} }, { put, call }) {
      const { data } = yield call(queryCustomerFollows, payload)
      return data
    },
    * queryReserve({ payload = {} }, { put, call }) {
      const { data } = yield call(queryCustomerReserves, payload)
      yield put({
        type: 'updateDetail',
        payload: {
          current: { reserve: data },
          loaded: { reserve: true },
        },
      })
    },
    * queryOrder({ payload = {} }, { put, call, select }) {
      const defaults = { pageNo: 1, pageSize: 10 }
      const res = yield call(queryOrders, { ...defaults, ...payload })
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      const { rows, totalCount } = res.data.orderVoPageEntity
      const orderPagination = yield select(({ personalPotentialList }) => personalPotentialList.orderPagination)
      yield put({
        type: 'updateDetail',
        payload: {
          current: { order: rows },
          loaded: { order: true },

        },
      })
      yield put({
        type: 'updateState', payload: {
          orderPagination: {
            ...orderPagination,
            current: payload.pageNo,
            total: totalCount
          }
        }
      })
    },
    * queryModify({ payload = {} }, { put, call }) {
      const defaults = { pageNo: 1, pageSize: 10 }
      const { data } = yield call(operationCustomer, { ...defaults, ...payload })
      yield put({
        type: 'updateDetail',
        payload: {
          current: { modify: data.rows },
          loaded: { modify: true },
        },
      })
      yield put({
        type: 'queryInfoInit',
        payload: { id: data.rows[data.rows.length - 1].id }
      })
    },
    * queryInfoInit({ payload = {} }, { put, call }) {
      const { data } = yield call(operationInti, { ...payload })
      yield put({
        type: 'updateState',
        payload: {
          infoInit: data
        },
      })
    },
    * queryOrderCount({ payload = {} }, { select, put, call }) {
      // const defaults = { pageNo: 1, pageSize: 10 }
      const { data } = yield call(queryOrderCount, { ...payload })
      const loaded = yield select(({ personalPotentialList }) => personalPotentialList.loaded)
      yield put({
        type: 'updateState',
        payload: {
          statistics: {
            orderCount: { ...data }
          },
          loaded: {
            ...loaded,
            statistics: true
          },
        }
      })
    },
    * queryReserveCount({ payload = {} }, { select, put, call }) {
      const defaults = { pageNo: 1, pageSize: 10 }
      const { code, data } = yield call(queryReserveCount, { ...defaults, ...payload })
      const statisticsPagination = yield select(({ personalPotentialList }) => personalPotentialList.statisticsPagination)
      const statistics = yield select(({ personalPotentialList }) => personalPotentialList.statistics)
      const loaded = yield select(({ personalPotentialList }) => personalPotentialList.loaded)
      if (code === 0 && data && data.rows) {
        yield put({
          type: 'updateState',
          payload: {
            statistics: {
              ...statistics,
              reserveCount: data.rows
            },
            loaded: {
              ...loaded,
              statistics: true
            },
            statisticsPagination: {
              ...statisticsPagination,
              reserveCount: {
                ...statisticsPagination.reserveCount,
                current: payload.pageNo,
                pageSize: data.pageSize || 10,
                total: data.totalCount
              }
            }
          }
        })
      }
    },
    *queryConsumptionCount({ payload = {} }, { select, put, call }) {
      const defaults = { pageNo: 1, pageSize: 10 }
      const { code, data } = yield call(queryConsumptionCount, { ...defaults, ...payload })
      const statisticsPagination = yield select(({ personalPotentialList }) => personalPotentialList.statisticsPagination)
      const statistics = yield select(({ personalPotentialList }) => personalPotentialList.statistics)
      const loaded = yield select(({ personalPotentialList }) => personalPotentialList.loaded)
      if (code === 0 && data && data.rows) {
        let newData = {
          orderCode: '汇总消耗',
          productName: '--',
          totalQuantity: data.consumptionSummaryResp.totalQuantity,
          consumptionCount: data.consumptionSummaryResp.consumptionCount,
          consumptionAmount: data.consumptionSummaryResp.consumptionAmount,
          unUsedCount: data.consumptionSummaryResp.unUsedCount,
          unUsedAmount: data.consumptionSummaryResp.unUsedAmount,
          refundAmount: data.consumptionSummaryResp.refundAmount,
          executorName: '--',
        }
        let consumptionCount = data.rows
        yield put({
          type: 'updateState',
          payload: {
            consumptionTotal: newData,
            statistics: {
              ...statistics,
              consumptionCount
            },
            loaded: {
              ...loaded,
              statistics: true
            },
            statisticsPagination: {
              ...statisticsPagination,
              consumptionCount: {
                ...statisticsPagination.consumptionCount,
                current: payload.pageNo,
                pageSize: data.pageSize || 10,
                total: data.totalCount
              }
            }
          }
        })
      }
    },
    * queryExecutor({ payload = {} }, { select, put, call }) {
      const { data } = yield call(queryExecutor, { ...payload })
      yield put({
        type: 'updateState',
        payload: { executorList: data }
      })
    },
    *queryCompact({ payload = {} }, { select, put, call }) {
      const { data } = yield call(queryCompact, { ...payload })
      yield put({
        type: 'updateDetail',
        payload: {
          current: { compact: data },
          loaded: { compact: true },
        },
      })
    },
    // 客户诊疗档案类型列表
    *queryServiceType({ payload = {} }, { select, put, call }) {
      const { data } = yield call(queryServiceType, { ...payload })
      yield put({
        type: 'updateDetail',
        payload: {
          current: { treatment: data },
          loaded: { treatment: true },
        },
      })
      yield put({
        type: 'queryBPSCustomerHistory',
        payload: { ...payload, taskableType: 'first_visit_bps_record_sheet' }
      })
      // if (data && data.length) {
      //   if(data[0].value === 'first_visit_bps_record_sheet'){
      //     yield put({
      //       type: 'queryBPSCustomerHistory',
      //       payload: { ...payload, taskableType: data[0].value }
      //     })
      //   }else{
      //     yield put({
      //       type: 'queryCustomerHistory',
      //       payload: { ...payload, taskableType: data[0].value }
      //     })
      //   }
      // }
    },

    *queryCustomerHistory({ payload = {} }, { select, put, call }) {
      const defaults = { pageNo: 1, pageSize: 10 }
      const { data } = yield call(queryCustomerHistory, { ...defaults, ...payload })
      const customerHistoryPagination = yield select(({ personalPotentialList }) => personalPotentialList.customerHistoryPagination)
      yield put({
        type: 'updateState',
        payload: {
          customerHistoryList: data.content,
          customerHistoryPagination: {
            ...customerHistoryPagination,
            current: payload.pageNo || 1,
            total: data.totalElements
          }
        },
      })
    },
    //查询BPS
    *queryBPSCustomerHistory({ payload = {} }, { select, put, call }) {
      const defaults = { pageNo: 1, pageSize: 10 }
      const { data } = yield call(queryBPSCustomerHistory, { ...defaults, ...payload })
      const customerHistoryPagination = yield select(({ personalPotentialList }) => personalPotentialList.customerHistoryPagination)
      yield put({
        type: 'updateState',
        payload: {
          customerHistoryList: data.content,
          customerHistoryPagination: {
            ...customerHistoryPagination,
            current: payload.pageNo || 1,
            total: data.totalElements
          }
        },
      })
    },

    * queryDetectionResult({ payload }, { call, put }) {
      const res = yield call(getDetectionResult, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      yield put({
        type: 'updateState',
        payload: {
          detectionResultModalVisible: true,
          detectionResult: res.data
        }
      })
    },

    * queryDemandResult({ payload }, { call, put }) {
      const res = yield call(queryRequirementAnalysis, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      yield put({
        type: 'updateState',
        payload: {
          demandResultModalVisible: true,
          demandResult: res.data
        }
      })
    },
    * queryEvaluationResult({ payload }, { call, put }) {
      const res = yield call(queryEvaluation, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      yield put({
        type: 'updateState',
        payload: {
          evaluationResultModalVisible: true,
          evaluationResult: res.data
        }
      })
    },
    * queryBPSResult({ payload }, { call, put }) {
      const res = yield call(queryBPSHostoryDetail, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      yield put({
        type: 'updateState',
        payload: {
          // bpsResultModalVisible: true,
          bspPrintLookvisibel: true,
          bpsResult: res.data || {},
        }
      })
    },
    * queryScaleResult({ payload }, { call, put }) {
      const res = yield call(getScaleResult, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      res.data = res.data || {}
      res.data.code = res.data.scaleEnum

      yield put({
        type: 'updateState',
        payload: {
          scaleResultModalVisible: true,
          scaleResult: res.data,
        }
      })
    },
    * queryPaintingResult({ payload }, { call, put }) {
      const res = yield call(queryDrawing, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      res.data = res.data || {}
      res.data.code = res.data.scaleEnum

      yield put({
        type: 'updateState',
        payload: {
          paintingResultModalVisible: true,
          paintingResult: res.data,
        }
      })
    },
    * querySandResult({ payload }, { call, put }) {
      const res = yield call(querySand, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      res.data = res.data || {}
      res.data.code = res.data.scaleEnum

      yield put({
        type: 'updateState',
        payload: {
          sandResultModalVisible: true,
          sandResult: res.data,
        }
      })
    },
    * querySubsequentResult({ payload }, { call, put }) {
      const res = yield call(querySubsequent, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      res.data = res.data || {}
      res.data.code = res.data.scaleEnum

      yield put({
        type: 'updateState',
        payload: {
          subsequentResultModalVisible: true,
          subsequentResult: res.data,
        }
      })
    },
    * queryHealingResult({ payload }, { call, put }) {
      const res = yield call(queryHealing, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      res.data = res.data || {}
      res.data.code = res.data.scaleEnum

      yield put({
        type: 'updateState',
        payload: {
          healingResultModalVisible: true,
          healingResult: res.data,
        }
      })
    },
    * queryHomePsychologyResult({ payload }, { call, put }) {
      const res = yield call(queryMentalTraining, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return

      res.data = res.data || {}
      res.data.code = res.data.scaleEnum

      yield put({
        type: 'updateState',
        payload: {
          homePsychologyResultModalVisible: true,
          homePsychologyResult: res.data,
        }
      })
    },
    *exportExcel({ payload = {} }, { put, call }) {
      const { data, fileName } = yield call(exportExcel, payload)
      downloadExcel(data, fileName)
    },
    *queryEmployeesByClinicId({ payload = {} }, { put, call }) {
      const { code, data } = yield call(queryEmployeesByClinicId, { clinic_id: localStorage.getItem(CLINIC_KEY) })
      if (code === 0 && data) {
        yield put({
          type: 'updateState',
          payload: {
            clinicUserList: data,
          }
        })
      }
    },
    *queryFiveTypeHistoryList({ payload = {} }, { put, call }) {
      const { code, data } = yield request(`${BASE_API}/customer/treatment_info/${payload.customerId}`)
      if (code === 0) {
        let newData = []
        if (data.evaluate_report && data.evaluate_report.length > 0) {
          newData.push({ key: '评估报告', list: data.evaluate_report })
        }
        if (data.psychological_service && data.psychological_service.length > 0) {
          newData.push({ key: '心理服务', list: data.psychological_service })
        }
        if (data.family_service && data.family_service.length > 0) {
          newData.push({ key: '家医服务', list: data.family_service })
        }
        if (data.special_examining && data.special_examining.length > 0) {
          newData.push({ key: '专科检测', list: data.special_examining })
        }
        if (data.other_service && data.other_service.length > 0) {
          newData.push({ key: '评估其他服务报告', list: data.other_service })
        }

        const res = yield call(fetchReportEvaluation, { phone: payload.phone, customerId: payload.customerId, pageNo: 1, pageSize: 100, token: '21eb6756ab004925b0ab7cd181ac998c' }) // 测评报告列表
        if (res.data && res.data.rows.length > 0) {
          // 当前用户产生的所有报告，包括自主小程序测评产生的报告、登记测评产生的报告、门店扫码测评产生的报告
          newData.push({ key: '测评报告', list: res.data.rows })
        }

        yield put({
          type: 'updateState',
          payload: {
            fiveTypeHistory: newData,
            serviceTeamList: { consultant: data.consultant, psychologyList: data.psychologyList }
          }
        })
      }

    },
    *queryStageExcelResult({ payload = {} }, { call, select, put }) {
      const res = yield call(fetchStageExcel, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return
      yield put({
        type: 'updateState',
        payload: {
          StageExcelModal: true,
          StageExcelData: res.data || {},
        }
      })
    },
    *queryStageEndExcelResult({ payload = {} }, { call, select, put }) {
      const res = yield call(fetchStageEndExcel, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return
      yield put({
        type: 'updateState',
        payload: {
          StageEndExcelModal: true,
          StageEndExcelData: res.data || {},
        }
      })
    },
    *queryExcel1Result({ payload = {} }, { call, select, put }) {
      const res = yield call(fetchExcel1, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return
      yield put({
        type: 'updateState',
        payload: {
          Excel1Modal: true,
          Excel1Data: res.data || {},
        }
      })
    },
    *queryRecordBriefResult({ payload = {} }, { call, select, put }) {
      const res = yield call(fetchSubsquentBrief, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return
      yield put({
        type: 'updateState',
        payload: {
          ExcelRecordBriefModal: true,
          ExcelRecordBriefData: res.data || {},
        }
      })
    },
    *queryServiceComplexResult({ payload = {} }, { call, select, put }) {
      const res = yield call(fetchServiceComolexExcel, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return
      yield put({
        type: 'updateState',
        payload: {
          ExcelServiceComolexModal: true,
          ExcelServiceComolexData: res.data || {},
        }
      })
    },
    *queryServiceTeamResult({ payload = {} }, { call, select, put }) {
      const res = yield call(fetchServiceTeam, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return
      yield put({
        type: 'updateState',
        payload: {
          serviceTeamList: res.data
        }
      })
    },
    *queryEvaluationNewData({ payload = {} }, { call, select, put }) {
      const res = yield call(queryNewEvaluation, payload)
      if (!res || res.code !== HTTP_SUCCESS_CODE) return
      yield put({
        type: 'updateState',
        payload: {
          showEvaluationNewModal: true,
          EvaluationNewModalData: res.data || {},
        }
      })
    },

  },
  reducers: {
    updateDetail(state, { payload }) {
      const { current, loaded } = payload
      return {
        ...state,
        current: {
          ...state.current,
          ...current,
        },
        loaded: {
          ...state.loaded,
          ...loaded
        }
      }
    },
    resetState(state, { payload }) {
      return {
        ...state,
        drawerVisible: false,
        modalVisible: false,
        modalType: 'add',
        demandVisible: false,
        demandType: 'add',
        demandItem: {},
        followVisible: false,
        followType: 'add',
        followItem: {},
        reserveVisible: false,
        orderReserveVisible: false,
        orderReserveItem: {},
        orderReserveType: 'add',
        reserveType: 'add',
        reserveItem: {},
        editDetail: {},
        current: {
          info: {},
          demand: [],
          modify: [],
          order: [],
          follow: [],
          reserve: [],
          treatment: []
        },
        loaded: {
          info: false,
          demand: false,
          modify: false,
          order: false,
          follow: false,
          reserve: false,
          treatment: false,
        },
        fchannels: [],
        tableLinkList: {},
        schannels: [],
        classification: [],
        customerStatus: [],
        customerStatusList: [],
        jobs: [],
        customerHistoryList: [],   //历史记录表
        customerHistoryPagination: {
          current: 1,
          total: 0,
          pageSize: PAGE_SIZE
        },
      }
    }
  }
})
